// // src/Pages/CookiePolicy.jsx
// import React from "react";
// import "./Legal.css";

// export default function CookiePolicy() {
//   return (
//     <div className="legal-page">
//       <h1>Cookie Policy</h1>
//       <p>Last updated: January 2026</p>

//       <p>
//         This Cookie Policy explains how EPSViewer.in ("we", "our", "us") uses
//         cookies and similar technologies when you visit our website.
//       </p>

//       <h2>What Are Cookies?</h2>
//       <p>
//         Cookies are small text files that are stored on your device when you
//         visit a website. They help websites function properly, remember user
//         preferences, and provide analytics to improve performance.
//       </p>

//       <h2>How We Use Cookies</h2>
//       <p>We use cookies for the following purposes:</p>
//       <ul>
//         <li>To ensure the website functions correctly</li>
//         <li>To remember user preferences and settings</li>
//         <li>To analyze website traffic and performance</li>
//         <li>To serve relevant advertisements through third-party services</li>
//       </ul>

//       <h2>Types of Cookies We Use</h2>
//       <ul>
//         <li>
//           <b>Essential Cookies:</b> Required for basic website functionality such
//           as navigation and file processing.
//         </li>
//         <li>
//           <b>Analytics Cookies:</b> Used to understand how users interact with
//           our website (for example, via Google Analytics).
//         </li>
//         <li>
//           <b>Advertising Cookies:</b> Used to display ads and measure ad
//           performance (for example, via Google AdSense).
//         </li>
//       </ul>

//       <h2>Third-Party Cookies</h2>
//       <p>
//         We may allow third-party services such as Google Analytics and Google
//         AdSense to place cookies on your device. These cookies are governed by
//         the privacy policies of those third parties.
//       </p>

//       <h2>How You Can Control Cookies</h2>
//       <p>
//         You can control or delete cookies at any time using your browser
//         settings. You may also configure your browser to block cookies
//         altogether; however, some parts of the website may not function
//         correctly if cookies are disabled.
//       </p>

//       <h2>Your Consent</h2>
//       <p>
//         By using EPSViewer.in, you consent to our use of cookies as described in
//         this Cookie Policy.
//       </p>

//       <h2>Updates to This Policy</h2>
//       <p>
//         We may update this Cookie Policy from time to time. Any changes will be
//         posted on this page with an updated revision date.
//       </p>

//       <h2>Contact Us</h2>
//       <p>
//         If you have any questions about this Cookie Policy, you can contact us
//         at: <b>support@magicapps.co.in</b>
//       </p>
//     </div>
//   );
// }







import React from "react";
import "./LegalPages.css"; // optional shared styling

export default function CookiePolicy() {
  return (
    <div className="legal-page">
      <h1>Cookie Policy – EPSViewer.in</h1>
      <p><b>Last updated:</b> January 2026</p>

      <p>
        This Cookie Policy explains how <b>EPSViewer.in</b> ("we", "us", or "our") uses cookies and similar
        technologies when you visit our website. It explains what these technologies are, why we use them,
        and your rights to control our use of them.
      </p>

      <h2>1. What Are Cookies?</h2>
      <p>
        Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you
        visit a website. Cookies help websites function properly, remember user preferences, and collect
        analytical data to improve user experience.
      </p>
      <ul>
        <li><b>Session Cookies</b> – deleted when you close your browser</li>
        <li><b>Persistent Cookies</b> – remain on your device for a set period</li>
        <li><b>First-party Cookies</b> – set by EPSViewer.in</li>
        <li><b>Third-party Cookies</b> – set by external services like analytics or advertising partners</li>
      </ul>

      <h2>2. How We Use Cookies</h2>
      <p>EPSViewer.in uses cookies for the following purposes:</p>

      <h3>a) Strictly Necessary Cookies</h3>
      <p>
        These cookies are essential for the operation of the Website. They allow you to upload and process
        EPS files, maintain your session, ensure secure browsing, and distribute website traffic properly.
        Without these cookies, some parts of the Website may not function correctly.
      </p>

      <h3>b) Preference & Functional Cookies</h3>
      <p>
        These cookies help us remember your language or layout preferences, improve usability and
        performance, and optimize the file preview and conversion experience.
      </p>

      <h3>c) Analytics & Performance Cookies</h3>
      <p>
        We use analytics cookies (for example, Google Analytics or similar tools) to understand how users
        interact with the Website, measure traffic and performance, and improve features and services.
        All analytics data is collected in an anonymized and aggregated form.
      </p>

      <h3>d) Advertising Cookies</h3>
      <p>
        We use advertising cookies to display relevant ads, limit the number of times you see an ad,
        and measure the effectiveness of advertising campaigns. These cookies are set by third-party
        advertising networks, including <b>Google AdSense</b>. Google and its partners use cookies to
        serve ads based on your visits to this and other websites. You can opt out of personalized
        advertising via{" "}
        <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google Ads Settings</a>{" "}
        or <a href="https://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">www.aboutads.info/choices</a>.
      </p>

      <h2>3. Third-Party Cookies</h2>
      <p>
        Some services used on EPSViewer.in may install cookies, including analytics services, advertising
        services, and external integrations (such as payment gateways or embedded content). These third
        parties may track your browsing activity across different websites. We do not control these
        cookies. Please refer to the respective third-party privacy policies for more details.
      </p>

      <h2>4. How to Manage or Disable Cookies</h2>
      <p>
        You can manage or delete cookies at any time using your browser settings. Most browsers allow you
        to view which cookies are stored, delete all or specific cookies, block third-party cookies, or
        disable all cookies completely.
      </p>
      <p>
        Disabling cookies may affect the functionality of EPSViewer.in and some features may not work as
        intended.
      </p>

      <h2>5. Withdrawing Your Consent</h2>
      <p>
        If cookies are installed based on your consent, you may withdraw your consent at any time by
        changing your browser cookie settings, clearing your browser cookies, or using opt-out tools
        provided by third-party services.
      </p>

      <h2>6. Owner and Data Controller</h2>
      <p>
        <b>Owner:</b> <a href="https://magicapps.co.in/" target="_blank" rel="noopener noreferrer">MagicApps</a><br />
        <b>Website:</b> https://www.epsviewer.in<br />
        <b>Support Email:</b> support@magicapps.co.in
      </p>

      <h2>7. Definitions</h2>
      <p>
        <b>Personal Data:</b> Any information that can directly or indirectly identify a person, such as IP
        address, device identifiers, or online behavior.
      </p>
      <p>
        <b>Usage Data:</b> Information collected automatically through this Website, which may include IP
        address, browser type, device type, pages visited, time spent on pages, operating system, and
        referring URLs.
      </p>
      <p>
        <b>User:</b> Any individual using this Website.
      </p>
      <p>
        <b>Data Controller (Owner):</b> The entity that determines the purposes and means of processing
        personal data.
      </p>

      <h2>8. Legal Information</h2>
      <p>
        This Cookie Policy is prepared in accordance with the General Data Protection Regulation (EU)
        2016/679 (GDPR), applicable Indian IT laws, and other international privacy standards. This Cookie
        Policy applies solely to EPSViewer.in unless stated otherwise.
      </p>

      <h2>9. Updates to This Cookie Policy</h2>
      <p>
        We may update this Cookie Policy from time to time to reflect legal, technical, or operational
        changes. Any updates will be posted on this page with a revised "Last updated" date.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions about this Cookie Policy or our use of cookies, please contact us:
      </p>
      <p>
        <b>Email:</b> support@magicapps.co.in<br />
        <b>Website:</b> https://www.epsviewer.in
      </p>
    </div>
  );
}
